import { Link } from 'react-router-dom';
import { AccordionNav } from './AccordionNav';
import { LinkItemProps } from './AppSidebar';
import SidebarNavItem from './SidebarNavItem';

type Props = {
  menuLinkData: Array<LinkItemProps>,
};

export default function SidebarNav({ menuLinkData }: Props) {
  return (
    <>
      {menuLinkData.map((navLink: LinkItemProps) =>
        navLink.link && !navLink.subMenu ? (
          <Link title={navLink.name} to={navLink.link} key={navLink.name}>
            <SidebarNavItem level={navLink.level} _hover={{bg: 'gray.700'}} icon={navLink.icon} link={navLink.link} name={navLink.name} />
          </Link>
        ) : !navLink.link && !navLink.subMenu ? (
          <SidebarNavItem level={navLink.level} icon={navLink.icon} key={navLink.name} link={navLink.link} name={navLink.name} />
        ) : (
          <AccordionNav name={navLink.name} icon={navLink.icon} level={navLink.level} subMenu={navLink.subMenu} key={navLink.name} />
        )
      )}
    </>
  );
}